<!-- START: dashboard -->
<nav class="cat__core__top-sidebar cat__core__top-sidebar--bg">
    <div class="pull-right">
        <a href="javascript: void(0);" class="btn btn-sm btn-outline-primary ladda-button">Update<span class="hidden-sm-down"> User</span></a>
        <a href="javascript: void(0);" class="btn btn-sm btn-outline-primary ladda-button">Add<span class="hidden-sm-down"> User</span></a>
    </div>
    <span class="cat__core__title d-block mb-2">
        <span class="text-muted">Home ·</span>
        <strong>Dashboard Beta</strong>
        <small class="text-muted">widgets, content blocks, tables, etc.</small>
    </span>
</nav>
<div class="row">
    <div class="col-xl-4">
        <div class="cat__core__widget cat__core__widget__2">
            <div class="cat__core__widget__2__head" style="background-image: url('assets/modules/dummy-assets/common/img/photos/5.jpeg');">
                <h2 class="text-white">
                    <strong>
                        Clean. Simple
                        <br />
                        Responsive
                    </strong>
                </h2>
            </div>
            <div class="cat__core__widget__2__content">
                <div class="cat__core__widget__2__left">
                    <a class="cat__core__avatar cat__core__avatar--90 cat__core__avatar--border-white" href="javascript:void(0);">
                        <img src="assets/modules/dummy-assets/common/img/avatars/5.jpg" alt="Alternative text to the image">
                    </a>
                    <br />
                    <strong>Helen Maggie</strong>
                    <br />
                    <span class="text-muted">@helen_m</span>
                </div>
                <div class="cat__core__widget__2__right">
                    <p>Lorem Ipsum is simply dummy text of the printing and typesetting industry.
                        Lorem Ipsum has been the industry's standard dummy text ever since the
                        1500s, when an unknown. Lorem Ipsum is simply dummy text of the printing and
                        typesetting industry.</p>
                </div>
            </div>
        </div>
    </div>
    <div class="col-xl-8">
        <div class="row">
            <div class="col-lg-4">
                <div class="cat__core__widget p-3">
                    <strong>Work Progress:</strong>
                    <p class="text-muted">Ipsum is simply dummy</p>
                    <div class="progress mb-3" style="height: 7px">
                        <div class="progress-bar progress-bar-striped progress-bar-animated" role="progressbar" aria-valuenow="40" aria-valuemin="0" aria-valuemax="100" style="width: 87%"></div>
                    </div>
                    <strong>Airplanes:</strong>
                    <p class="text-muted">Typesetting industry</p>
                    <div class="progress mb-3" style="height: 7px">
                        <div class="progress-bar progress-bar-striped progress-bar-animated" role="progressbar" aria-valuenow="40" aria-valuemin="0" aria-valuemax="100" style="width: 20%"></div>
                    </div>
                    <strong>Robots:</strong>
                    <p class="text-muted">Typesetting industry</p>
                    <div class="progress mb-3" style="height: 7px">
                        <div class="progress-bar progress-bar-striped progress-bar-animated" role="progressbar" aria-valuenow="40" aria-valuemin="0" aria-valuemax="100" style="width: 35%"></div>
                    </div>
                    <strong>Automotive:</strong>
                    <p class="text-muted">Typesetting industry</p>
                    <div class="progress mb-3" style="height: 7px">
                        <div class="progress-bar progress-bar-striped progress-bar-animated" role="progressbar" aria-valuenow="40" aria-valuemin="0" aria-valuemax="100" style="width: 56%"></div>
                    </div>
                    <strong>Total Time:</strong>
                    <p class="text-muted">Printing and typesetting</p>
                    <div class="progress mb-3" style="height: 7px">
                        <div class="progress-bar progress-bar-striped progress-bar-animated bg-danger" role="progressbar" aria-valuenow="40" aria-valuemin="0" aria-valuemax="100" style="width: 18%"></div>
                    </div>
                </div>
            </div>
            <div class="col-lg-4">
                <div class="cat__core__widget cat__core__widget__3 bg-default">
                    <div class="carousel slide" id="carousel-1" data-ride="carousel">
                        <ol class="carousel-indicators">
                            <li data-target="#carousel-1" data-slide-to="0" class="active"></li>
                            <li data-target="#carousel-1" data-slide-to="1" class=""></li>
                        </ol>
                        <div class="carousel-inner" role="listbox">
                            <div class="carousel-item active">
                                <a href="javascript: void(0);" class="cat__core__widget__3__body text-white">
                                    <div class="cat__core__widget__3__icon">
                                        <i class="icmn-accessibility"></i>
                                    </div>
                                    <h2>Sales Growth</h2>
                                    <p>View Report</p>
                                </a>
                            </div>
                            <div class="carousel-item">
                                <a href="javascript: void(0);" class="cat__core__widget__3__body text-white">
                                    <div class="cat__core__widget__3__icon">
                                        <i class="icmn-download"></i>
                                    </div>
                                    <h2>All Reports</h2>
                                    <p>Pdf Download</p>
                                </a>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="cat__core__widget cat__core__widget__3 bg-default">
                    <div class="carousel slide" id="carousel-2" data-ride="carousel">
                        <ol class="carousel-indicators">
                            <li data-target="#carousel-2" data-slide-to="0" class="active"></li>
                            <li data-target="#carousel-2" data-slide-to="1" class=""></li>
                        </ol>
                        <div class="carousel-inner" role="listbox">
                            <div class="carousel-item active">
                                <a href="javascript: void(0);" class="cat__core__widget__3__body text-white">
                                    <div class="cat__core__widget__3__icon">
                                        <i class="icmn-books"></i>
                                    </div>
                                    <h2>
                                        <i class="icmn-books"></i> Todo
                                    </h2>
                                    <p>
                                        1. Upgrade
                                        <br />
                                        2. Finish
                                    </p>
                                </a>
                            </div>
                            <div class="carousel-item">
                                <a href="javascript: void(0);" class="cat__core__widget__3__body text-white">
                                    <div class="cat__core__widget__3__icon">
                                        <i class="icmn-download"></i>
                                    </div>
                                    <h2>
                                        <i class="icmn-download"></i> Finish
                                    </h2>
                                    <p>
                                        1. Upgrade
                                        <br />
                                        2. Prepare
                                    </p>
                                </a>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="cat__core__widget p-3">
                    <p class="m-0">Text widget. Lorem Ipsum is simply dummy text of the printing and typesetting industry.
                        Lorem Ipsum has been the industry's standard dummy.</p>
                </div>
            </div>
            <div class="col-lg-4">
                <div class="cat__core__widget bg-warning text-white p-3">
                    <p class="m-0">Text widget. Lorem Ipsum is simply dummy text of the printing and typesetting industry.
                        Lorem Ipsum has been the industry's standard dummy.</p>
                </div>
                <div class="cat__core__widget cat__core__widget__3">
                    <div class="carousel slide" id="carousel-3" data-ride="carousel">
                        <ol class="carousel-indicators">
                            <li data-target="#carousel-3" data-slide-to="0" class="active"></li>
                            <li data-target="#carousel-3" data-slide-to="1" class=""></li>
                        </ol>
                        <div class="carousel-inner" role="listbox">
                            <div class="carousel-item active">
                                <a href="javascript: void(0);" class="cat__core__widget__3__body">
                                    <div class="cat__core__widget__3__icon">
                                        <i class="icmn-accessibility"></i>
                                    </div>
                                    <h2>Sales Growth</h2>
                                    <p>View Report</p>
                                </a>
                            </div>
                            <div class="carousel-item">
                                <a href="javascript: void(0);" class="cat__core__widget__3__body">
                                    <div class="cat__core__widget__3__icon">
                                        <i class="icmn-download"></i>
                                    </div>
                                    <h2>All Reports</h2>
                                    <p>Pdf Download</p>
                                </a>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="cat__core__widget cat__core__widget__3">
                    <div class="carousel slide" id="carousel-4" data-ride="carousel">
                        <ol class="carousel-indicators">
                            <li data-target="#carousel-4" data-slide-to="0" class="active"></li>
                            <li data-target="#carousel-4" data-slide-to="1" class=""></li>
                        </ol>
                        <div class="carousel-inner" role="listbox">
                            <div class="carousel-item active">
                                <a href="javascript: void(0);" class="cat__core__widget__3__body">
                                    <div class="cat__core__widget__3__icon">
                                        <i class="icmn-books"></i>
                                    </div>
                                    <h2>
                                        <i class="icmn-books"></i> Todo
                                    </h2>
                                    <p>
                                        1. Upgrade
                                        <br />
                                        2. Finish
                                    </p>
                                </a>
                            </div>
                            <div class="carousel-item">
                                <a href="javascript: void(0);" class="cat__core__widget__3__body">
                                    <div class="cat__core__widget__3__icon">
                                        <i class="icmn-download"></i>
                                    </div>
                                    <h2>
                                        <i class="icmn-download"></i> Finish
                                    </h2>
                                    <p>
                                        1. Upgrade
                                        <br />
                                        2. Prepare
                                    </p>
                                </a>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
<div class="row">
    <div class="col-lg-4">
        <div class="cat__core__widget">
            <table class="table mb-0">
                <thead>
                <tr>
                    <th class="border-top-0">#</th>
                    <th class="border-top-0">First Name</th>
                    <th class="border-top-0">Username</th>
                    <th class="border-top-0 hidden-lg-down">Levels</th>
                    <th class="border-top-0"></th>
                </tr>
                </thead>
                <tbody>
                <tr>
                    <th scope="row">
                        <input type="checkbox">
                    </th>
                    <td><a href="javascript: void(0);" class="cat__core__link--underlined cat__core__link--blue" data-toggle="tooltip" data-placement="right" title="" data-original-title="User #1">Mark Stevenson</a></td>
                    <td>@mdo</td>
                    <td class="hidden-lg-down">
                        <div class="cat__core__steps-inline d-block">
                            <a href="javascript: void(0);" class="cat__core__step cat__core__step--success">1</a>
                            <a href="javascript: void(0);" class="cat__core__step cat__core__step--success">2</a>
                        </div>
                    </td>
                    <td>
                        <div class="dropdown pull-right">
                            <button type="button" class="btn btn-sm dropdown-toggle" data-toggle="dropdown" aria-expanded="false">
                                Actions
                            </button>
                            <ul class="dropdown-menu dropdown-menu-right" aria-labelledby="" role="menu">
                                <a class="dropdown-item" href="javascript: void(0)">Action</a>
                                <a class="dropdown-item" href="javascript: void(0)">Another action</a>
                                <a class="dropdown-item" href="javascript: void(0)">Something else here</a>
                                <div class="dropdown-divider"></div>
                                <a class="dropdown-item" href="javascript: void(0)">Separated link</a>
                            </ul>
                        </div>
                    </td>
                </tr>
                <tr>
                    <th scope="row">
                        <input type="checkbox">
                    </th>
                    <td><a href="javascript: void(0);" class="cat__core__link--underlined cat__core__link--blue" data-toggle="tooltip" data-placement="right" title="" data-original-title="User #2">Jacob Hoffman</a></td>
                    <td>@fat</td>
                    <td class="hidden-lg-down">
                        <div class="cat__core__steps-inline d-block">
                            <a href="javascript: void(0);" class="cat__core__step cat__core__step--success">1</a>
                            <a href="javascript: void(0);" class="cat__core__step">2</a>
                        </div>
                    </td>
                    <td>
                        <div class="dropdown pull-right">
                            <button type="button" class="btn btn-sm dropdown-toggle" data-toggle="dropdown" aria-expanded="false">
                                Actions
                            </button>
                            <ul class="dropdown-menu dropdown-menu-right" aria-labelledby="" role="menu">
                                <a class="dropdown-item" href="javascript: void(0)">Action</a>
                                <a class="dropdown-item" href="javascript: void(0)">Another action</a>
                                <a class="dropdown-item" href="javascript: void(0)">Something else here</a>
                                <div class="dropdown-divider"></div>
                                <a class="dropdown-item" href="javascript: void(0)">Separated link</a>
                            </ul>
                        </div>
                    </td>
                </tr>
                <tr>
                    <th scope="row">
                        <input type="checkbox">
                    </th>
                    <td><a href="javascript: void(0);" class="cat__core__link--underlined cat__core__link--blue" data-toggle="tooltip" data-placement="right" title="" data-original-title="User #3">Larry Page</a></td>
                    <td>@twitter</td>
                    <td class="hidden-lg-down">
                        <div class="cat__core__steps-inline d-block">
                            <a href="javascript: void(0);" class="cat__core__step cat__core__step--primary">1</a>
                            <a href="javascript: void(0);" class="cat__core__step">2</a>
                        </div>
                    </td>
                    <td>
                        <div class="dropdown pull-right">
                            <button type="button" class="btn btn-sm dropdown-toggle" data-toggle="dropdown" aria-expanded="false">
                                Actions
                            </button>
                            <ul class="dropdown-menu dropdown-menu-right" aria-labelledby="" role="menu">
                                <a class="dropdown-item" href="javascript: void(0)">Action</a>
                                <a class="dropdown-item" href="javascript: void(0)">Another action</a>
                                <a class="dropdown-item" href="javascript: void(0)">Something else here</a>
                                <div class="dropdown-divider"></div>
                                <a class="dropdown-item" href="javascript: void(0)">Separated link</a>
                            </ul>
                        </div>
                    </td>
                </tr>
                <tr>
                    <th scope="row">
                        <input type="checkbox">
                    </th>
                    <td><a href="javascript: void(0);" class="cat__core__link--underlined cat__core__link--blue" data-toggle="tooltip" data-placement="right" title="" data-original-title="User #1">Mark Stevenson</a></td>
                    <td>@mdo</td>
                    <td class="hidden-lg-down">
                        <div class="cat__core__steps-inline d-block">
                            <a href="javascript: void(0);" class="cat__core__step cat__core__step--success">1</a>
                            <a href="javascript: void(0);" class="cat__core__step cat__core__step--success">2</a>
                        </div>
                    </td>
                    <td>
                        <div class="dropdown pull-right">
                            <button type="button" class="btn btn-sm dropdown-toggle" data-toggle="dropdown" aria-expanded="false">
                                Actions
                            </button>
                            <ul class="dropdown-menu dropdown-menu-right" aria-labelledby="" role="menu">
                                <a class="dropdown-item" href="javascript: void(0)">Action</a>
                                <a class="dropdown-item" href="javascript: void(0)">Another action</a>
                                <a class="dropdown-item" href="javascript: void(0)">Something else here</a>
                                <div class="dropdown-divider"></div>
                                <a class="dropdown-item" href="javascript: void(0)">Separated link</a>
                            </ul>
                        </div>
                    </td>
                </tr>
                <tr>
                    <th scope="row">
                        <input type="checkbox">
                    </th>
                    <td><a href="javascript: void(0);" class="cat__core__link--underlined cat__core__link--blue" data-toggle="tooltip" data-placement="right" title="" data-original-title="User #2">Jacob Hoffman</a></td>
                    <td>@fat</td>
                    <td class="hidden-lg-down">
                        <div class="cat__core__steps-inline d-block">
                            <a href="javascript: void(0);" class="cat__core__step cat__core__step--success">1</a>
                            <a href="javascript: void(0);" class="cat__core__step">2</a>
                        </div>
                    </td>
                    <td>
                        <div class="dropdown pull-right">
                            <button type="button" class="btn btn-sm dropdown-toggle" data-toggle="dropdown" aria-expanded="false">
                                Actions
                            </button>
                            <ul class="dropdown-menu dropdown-menu-right" aria-labelledby="" role="menu">
                                <a class="dropdown-item" href="javascript: void(0)">Action</a>
                                <a class="dropdown-item" href="javascript: void(0)">Another action</a>
                                <a class="dropdown-item" href="javascript: void(0)">Something else here</a>
                                <div class="dropdown-divider"></div>
                                <a class="dropdown-item" href="javascript: void(0)">Separated link</a>
                            </ul>
                        </div>
                    </td>
                </tr>
                <tr>
                    <th scope="row">
                        <input type="checkbox">
                    </th>
                    <td><a href="javascript: void(0);" class="cat__core__link--underlined cat__core__link--blue" data-toggle="tooltip" data-placement="right" title="" data-original-title="User #1">Mark Stevenson</a></td>
                    <td>@mdo</td>
                    <td class="hidden-lg-down">
                        <div class="cat__core__steps-inline d-block">
                            <a href="javascript: void(0);" class="cat__core__step cat__core__step--success">1</a>
                            <a href="javascript: void(0);" class="cat__core__step cat__core__step--success">2</a>
                        </div>
                    </td>
                    <td>
                        <div class="dropdown pull-right">
                            <button type="button" class="btn btn-sm dropdown-toggle" data-toggle="dropdown" aria-expanded="false">
                                Actions
                            </button>
                            <ul class="dropdown-menu dropdown-menu-right" aria-labelledby="" role="menu">
                                <a class="dropdown-item" href="javascript: void(0)">Action</a>
                                <a class="dropdown-item" href="javascript: void(0)">Another action</a>
                                <a class="dropdown-item" href="javascript: void(0)">Something else here</a>
                                <div class="dropdown-divider"></div>
                                <a class="dropdown-item" href="javascript: void(0)">Separated link</a>
                            </ul>
                        </div>
                    </td>
                </tr>
                </tbody>
            </table>
        </div>
    </div>
    <div class="col-lg-4">
        <div class="cat__core__widget">
            <p class="pt-3 px-3"><strong>REVENUE STATISTICS</strong></p>
            <div class="chart-line height-300 chartist"></div>
        </div>
    </div>
    <div class="col-lg-4">
        <div class="cat__core__widget">
            <p class="pt-3 px-3"><strong>SITE VISITS GROWTH</strong></p>
            <div class="chart-overlapping-bar height-300 chartist"></div>
        </div>
    </div>
</div>
<div class="row">
    <div class="col-lg-3">
        <div class="cat__core__widget">
            <div class="cat__core__step cat__core__step--success">
                <span class="cat__core__step__digit">
                    <i class="icmn-database"><!-- --></i>
                </span>
                <div class="cat__core__step__desc">
                    <span class="cat__core__step__title">Databases</span>
                    <p>Total: 61756</p>
                </div>
            </div>
        </div>
    </div>
    <div class="col-lg-3">
        <div class="cat__core__widget">
            <div class="cat__core__step cat__core__step--primary">
                <span class="cat__core__step__digit">
                    <i class="icmn-users"><!-- --></i>
                </span>
                <div class="cat__core__step__desc">
                    <span class="cat__core__step__title">Users</span>
                    <p>Total: 7658</p>
                </div>
            </div>
        </div>
    </div>
    <div class="col-lg-3">
        <div class="cat__core__widget">
            <div class="cat__core__step cat__core__step--danger">
                <span class="cat__core__step__digit">
                    <i class="icmn-bullhorn"><!-- --></i>
                </span>
                <div class="cat__core__step__desc">
                    <span class="cat__core__step__title">Connections</span>
                    <p>Growth: 56%</p>
                </div>
            </div>
        </div>
    </div>
    <div class="col-lg-3">
        <div class="cat__core__widget">
            <div class="cat__core__step cat__core__step--default">
                <span class="cat__core__step__digit">
                    <i class="icmn-price-tags"><!-- --></i>
                </span>
                <div class="cat__core__step__desc">
                    <span class="cat__core__step__title">Sales</span>
                    <p>Total: 646</p>
                </div>
            </div>
        </div>
    </div>
</div>
<div class="row">
    <div class="col-xl-6">
        <div class="row">
            <div class="col-md-4">
                <div class="cat__core__widget px-3 py-5">
                    <div class="cat__core__widget__2__icon text-center font-size-30">
                        <i class="icmn-database"></i>
                    </div>
                    <div class="mt-2 text-center">
                        <p>Lorem Ipsum is simply dummy text of printing the printing and typesetti...</p>
                        <a href="javascript: void(0)" class="btn btn-outline-danger">Information</a>
                    </div>
                </div>
            </div>
            <div class="col-md-4">
                <div class="cat__core__widget px-3 py-5">
                    <div class="cat__core__widget__2__icon text-center font-size-30">
                        <i class="icmn-users"></i>
                    </div>
                    <div class="mt-2 text-center">
                        <p>Lorem Ipsum is simply dummy text of printing the printing and typesetti...</p>
                        <a href="javascript: void(0)" class="btn btn-outline-danger">Information</a>
                    </div>
                </div>
            </div>
            <div class="col-md-4">
                <div class="cat__core__widget px-3 py-5">
                    <div class="cat__core__widget__2__icon text-center font-size-30">
                        <i class="icmn-home"></i>
                    </div>
                    <div class="mt-2 text-center">
                        <p class="text-muted">Lorem Ipsum is simply dummy text of printing the printing and typesetti...</p>
                        <a href="javascript: void(0)" class="btn btn-outline-success">Information</a>
                    </div>
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-md-4">
                <div class="cat__core__widget cat__core__widget__1 bg-warning text-white px-3 py-5">
                    <div class="cat__core__widget__1__plus"></div>
                    <a class="cat__core__avatar cat__core__avatar--90 cat__core__avatar--border-white d-block mx-auto" href="javascript:void(0);">
                        <img src="assets/modules/dummy-assets/common/img/avatars/1.jpg" alt="Alternative text to the image">
                    </a>
                    <div class="my-3 text-center">
                        <strong class="font-size-18">Artour Aniston</strong>
                        <br>
                        <span>Project Manager</span>
                    </div>
                    <div class="text-center">
                        <div class="btn-group text-center">
                            <button type="button" class="btn btn-sm btn-rounded">Add</button>
                            <button type="button" class="btn btn-sm btn-rounded">Inbox</button>
                        </div>
                    </div>
                </div>
            </div>
            <div class="col-md-4">
                <div class="cat__core__widget cat__core__widget__1 bg-default text-white px-3 py-5">
                    <div class="cat__core__widget__1__plus"></div>
                    <a class="cat__core__avatar cat__core__avatar--90 cat__core__avatar--border-white d-block mx-auto" href="javascript:void(0);">
                        <img src="assets/modules/dummy-assets/common/img/avatars/3.jpg" alt="Alternative text to the image">
                    </a>
                    <div class="my-3 text-center">
                        <strong class="font-size-18">David Lee</strong>
                        <br />
                        <span>PHP Coder</span>
                    </div>
                    <div class="text-center">
                        <div class="btn-group text-center">
                            <button type="button" class="btn btn-sm btn-rounded">Add</button>
                            <button type="button" class="btn btn-sm btn-rounded">Inbox</button>
                        </div>
                    </div>
                </div>
            </div>
            <div class="col-md-4">
                <div class="cat__core__widget cat__core__widget__1 px-3 py-5">
                    <div class="cat__core__widget__1__plus"></div>
                    <a class="cat__core__avatar cat__core__avatar--90 cat__core__avatar--border d-block mx-auto" href="javascript:void(0);">
                        <img src="assets/modules/dummy-assets/common/img/avatars/5.jpg" alt="Alternative text to the image">
                    </a>
                    <div class="my-3 text-center">
                        <strong class="font-size-18">Aston Martin</strong>
                        <br />
                        <span class="text-muted">Director</span>
                    </div>
                    <div class="text-center">
                        <div class="btn-group text-center">
                            <button type="button" class="btn btn-sm btn-rounded">Add</button>
                            <button type="button" class="btn btn-sm btn-rounded">Inbox</button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="col-xl-6">
        <div class="cat__core__widget p-3">
            <div class="cat__apps__messaging">
                <div class="custom-scroll cat__core__scrollable" style="height: 26.25rem;">
                    <div class="cat__apps__chat-block">
                        <div class="cat__apps__chat-block__item clearfix">
                            <div class="cat__apps__chat-block__avatar">
                                <a class="cat__core__avatar" href="javascript:void(0);">
                                    <img src="assets/modules/dummy-assets/common/img/avatars/3.jpg" alt="Alternative text to the image" />
                                </a>
                            </div>
                            <div class="cat__apps__chat-block__content">
                                <strong>David Scott</strong>
                                <p>Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum is simply dummy text of the printing and typesetting industry</p>
                            </div>
                        </div>
                        <div class="cat__apps__chat-block__item clearfix">
                            <div class="cat__apps__chat-block__avatar">
                                <a class="cat__core__avatar" href="javascript:void(0);">
                                    <img src="assets/modules/dummy-assets/common/img/avatars/3.jpg" alt="Alternative text to the image" />
                                </a>
                            </div>
                            <div class="cat__apps__chat-block__content">
                                <strong>Chris Smith</strong>
                                <p>Lorem Ipsum is simply dummy text of the printing</p>
                                <img class="cat__apps__profile__wall__message-img" alt="photos" src="assets/modules/dummy-assets/common/img/photos/4.jpeg" />
                                <img class="cat__apps__profile__wall__message-img" alt="photos" src="assets/modules/dummy-assets/common/img/photos/3.jpeg" />
                            </div>
                        </div>
                        <div class="cat__apps__chat-block__item cat__apps__chat-block__item--right clearfix">
                            <div class="cat__apps__chat-block__avatar">
                                <a class="cat__core__avatar" href="javascript:void(0);">
                                    <img src="assets/modules/dummy-assets/common/img/avatars/4.jpg" alt="Alternative text to the image" />
                                </a>
                            </div>
                            <div class="cat__apps__chat-block__content">
                                <strong>Donald Trump</strong>
                                <p>Ok. Thanks!</p>
                            </div>
                        </div>
                        <div class="cat__apps__chat-block__item cat__apps__chat-block__item--right clearfix">
                            <div class="cat__apps__chat-block__avatar">
                                <a class="cat__core__avatar" href="javascript:void(0);">
                                    <img src="assets/modules/dummy-assets/common/img/avatars/4.jpg" alt="Alternative text to the image" />
                                </a>
                            </div>
                            <div class="cat__apps__chat-block__content">
                                <strong>Donald Trump</strong>
                                <p>Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum is simply dummy</p>
                            </div>
                        </div>
                        <div class="cat__apps__chat-block__item clearfix">
                            <div class="cat__apps__chat-block__avatar">
                                <a class="cat__core__avatar" href="javascript:void(0);">
                                    <img src="assets/modules/dummy-assets/common/img/avatars/3.jpg" alt="Alternative text to the image" />
                                </a>
                            </div>
                            <div class="cat__apps__chat-block__content">
                                <strong>David Scott</strong>
                                <p>Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum is simply dummy text of the printing and typesetting industry</p>
                            </div>
                        </div>
                        <div class="cat__apps__chat-block__item cat__apps__chat-block__item--right clearfix">
                            <div class="cat__apps__chat-block__avatar">
                                <a class="cat__core__avatar" href="javascript:void(0);">
                                    <img src="assets/modules/dummy-assets/common/img/avatars/4.jpg" alt="Alternative text to the image" />
                                </a>
                            </div>
                            <div class="cat__apps__chat-block__content">
                                <strong>Donald Trump</strong>
                                <p>Ok. Thanks!</p>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="form-group mt-4 mb-0">
                    <textarea class="form-control adjustable-textarea" placeholder="Type and press enter"></textarea>
                    <div class="mt-3">
                        <button class="btn btn-sm btn-primary width-100">
                            <i class="fa fa-send mr-2"></i>
                            Send
                        </button>
                        <button class="btn btn-link">
                            Attach File
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
<div class="row">
    <div class="col-lg-12">
        <div class="cat__core__widget">
            <div class="table-responsive">
                <table class="table table-hover nowrap" width="100%">
                    <thead class="thead-inverse">
                    <tr>
                        <th>Name</th>
                        <th>Position</th>
                        <th>Office</th>
                        <th>Age</th>
                        <th>Date</th>
                        <th>Salary</th>
                    </tr>
                    </thead>
                    <tfoot>
                    <tr>
                        <th>Name</th>
                        <th>Position</th>
                        <th>Office</th>
                        <th>Age</th>
                        <th>Date</th>
                        <th>Salary</th>
                    </tr>
                    </tfoot>
                    <tbody>
                    <tr>
                        <td>Damon</td>
                        <td>5516 Adolfo Green</td>
                        <td>Littelhaven</td>
                        <td>85</td>
                        <td>2014/06/13</td>
                        <td>$553,536</td>
                    </tr>
                    <tr>
                        <td>Torrey</td>
                        <td>1995 Richie Neck</td>
                        <td>West Sedrickstad</td>
                        <td>77</td>
                        <td>2014/09/12</td>
                        <td>$243,577</td>
                    </tr>
                    <tr>
                        <td>Miracle</td>
                        <td>176 Hirthe Squares</td>
                        <td>Ryleetown</td>
                        <td>82</td>
                        <td>2013/09/27</td>
                        <td>$784,802</td>
                    </tr>
                    <tr>
                        <td>Damon</td>
                        <td>5516 Adolfo Green</td>
                        <td>Littelhaven</td>
                        <td>85</td>
                        <td>2014/06/13</td>
                        <td>$553,536</td>
                    </tr>
                    <tr>
                        <td>Torrey</td>
                        <td>1995 Richie Neck</td>
                        <td>West Sedrickstad</td>
                        <td>77</td>
                        <td>2014/09/12</td>
                        <td>$243,577</td>
                    </tr>
                    <tr>
                        <td>Miracle</td>
                        <td>176 Hirthe Squares</td>
                        <td>Ryleetown</td>
                        <td>82</td>
                        <td>2013/09/27</td>
                        <td>$784,802</td>
                    </tr>
                    </tbody>
                </table>
            </div>
        </div>
    </div>
</div>
<!-- END: page scripts -->
